var map = {
	"./Black.mp3": 7847,
	"./BlueGreen.mp3": 916,
	"./BlueViolet.mp3": 1350,
	"./Brown.mp3": 8522,
	"./Gold.mp3": 6912,
	"./Gray.mp3": 4442,
	"./Green.mp3": 4996,
	"./Maroon.mp3": 1077,
	"./Orange.mp3": 8898,
	"./Pink.mp3": 4604,
	"./Red.mp3": 7471,
	"./RedOrange.mp3": 6453,
	"./RedViolet.mp3": 8744,
	"./SkyBlue.mp3": 7106,
	"./White.mp3": 6163,
	"./Yellow.mp3": 9938,
	"./YellowGreen.mp3": 9091,
	"./YellowOrange.mp3": 2803,
	"./blue.mp3": 6327,
	"./violet.mp3": 5568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9562;